import { render, staticRenderFns } from "./UIform.vue?vue&type=template&id=4345cd6c&scoped=true&"
import script from "./UIform.vue?vue&type=script&lang=js&"
export * from "./UIform.vue?vue&type=script&lang=js&"
import style0 from "./UIform.vue?vue&type=style&index=0&id=4345cd6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4345cd6c",
  null
  
)

export default component.exports